import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory, useParams } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { getBoardDetail, updateBoardData } from "crud/search.crud";
import SelectBox from "components/RopikCustom/SelectBox";
import FilePreview from "components/RopikCustom/FilePreview";


const initInputCondition = {
  subject: '',
  type: 'data',
  productType: '',
  price: '',
  qty: '',
  content: ''
};

const NoticeUpdate = () => {
  const { id } = useParams();
  const history = useHistory()

  const [inputItem, setInputItem] = useState(initInputCondition)
  const [isLoading, setIsLoading] = useState(false)
  const [files, setFiles] = useState([]);
  const [previewImages, setPreviewImages] = useState([])
  const [deletedFiles, setDeletedFiles] = useState([])

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({ ...prev, [key]: value }))
  }

  const isValidated = () => {
    if (!inputItem.subject) {
      alert('제목을 입력해 주세요')
      return false
    } else if (!inputItem.content) {
      alert('내용을 입력해 주세요')
      return false
    }
    return true
  }

  const saveData = async () => {
    if (isLoading)
      return
    setIsLoading(true)

    try {
      const fd = new FormData();

      let newFiles = files.filter(i => !i.id)
      for (let i = 0; i < newFiles.length; i++) {
        let newFile = new File([newFiles[i]], `${encodeURI(newFiles[i].name)}`, { type: newFiles[i].type })
        fd.append('file_' + i, newFile);
      }

      fd.append('deleted_files', JSON.stringify(deletedFiles))

      const params = {
        id: id,
        subject: inputItem.subject || '',
        content: inputItem.content || '',
        type: 'notice'
      }

      fd.append('board_data', JSON.stringify(params))

      const response = await updateBoardData(fd);
      if (response.data?.result === 'success') {
        setIsLoading(false)
        history.push(`/notice-detail/${id}`)
      } else {
        setIsLoading(false)
      }
      alert(response.data.msg)

    } catch (e) {
      setIsLoading(false)
      console.log(e)
    }
  }
    
  const getDetailData = async () => {
    if (isLoading)
      return

    setIsLoading(true)
    try {
      const params = {
        id: id
      }

      const response = await getBoardDetail(params);
      if (response.data.result === 'success') {
        const content = response.data.data || {}
        setInputItem({
          subject: content.subject,
          type: content.type || '',
          productType: content.product_type || '',
          price: content.price || '',
          qty: content.qty || '',
          content: content.content || ''
        })
        setPreviewImages(content.board_file)
        setFiles(content.board_file)
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }

  const handleFileChange = (event) => {
    const newFiles = event.target.files;
    let prevTmp = [];
    for (let i = 0; i < newFiles.length; i++) {
      let item = {
        name: newFiles[i].name,
        path: URL.createObjectURL(newFiles[i]),
      }
      prevTmp.push(item)
    }
    let tmp = [...files, ...newFiles];
    let previewTmp = [...previewImages, ...prevTmp]
    tmp = tmp.filter((v, i) => { return i - 5 < 0 })
    setFiles(tmp)
    previewTmp = previewTmp.filter((v, i) => { return i - 5 < 0 })
    setPreviewImages(previewTmp);
  }

  const deleteImage = (index) => {
    if (files[index].id) {
      setDeletedFiles([...deletedFiles, files[index].id])
    }
    setFiles(files.filter((v, i) => { return i !== index; }))
    setPreviewImages(previewImages.filter((v, i) => { return i !== index; }))
  }
  
  useEffect(() => {
    getDetailData()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>자료실 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="자료실" breadcrumbItem="자료 수정" />

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 제목</td>
                          <td colSpan="4" className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.subject} placeholder="제목을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('subject', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 내용</td>
                          <td colSpan="4" className="w-40">
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="내용을 입력해 주세요" value={inputItem.content}
                              onChange={(e) => {
                                changeInputCondition('content', e.target.value);
                              }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">사진 첨부</td>
                          <td className="w-90">
                            <input style={{ display: "none" }} type="file" id="getFile" accept="image/*" multiple="multiple" onChange={(e) => {
                              handleFileChange(e)
                            }} />
                            <label htmlFor="getFile" type="button" className="custom-btn secondary-bg border-radius-0 white-text border-none mb-0 text-center">
                              파일 선택 ({previewImages.length} / 5)
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">미리보기</td>
                          <td className="w-90">
                            <FilePreview arr={previewImages} handleDelete={deleteImage} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: 310 }} className="d-flex justify-content-between margin-bottom-25">
            <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => { history.push('/data-room') }}>
              목록으로 이동
            </button>
            <div className="d-flex">
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                if (isValidated()) {
                  saveData()
                }
              }}>
                작성 완료
              </button>
            </div>
          </div>
        </Container>
      </div>

    </React.Fragment>

  )
}

export default NoticeUpdate
